import { createFileRoute, Link } from "@tanstack/react-router";
import { PageHeader } from "./fordon";
import { GLOSSARY } from "@/data/husbil-glossary";

export const Route = createFileRoute("/ordlista/")({
  // Ordlistedatan byggs i loadern så den hamnar i sidans egen chunk.
  codeSplitGroupings: [["loader", "component"]],
  loader: () => ({
    terms: GLOSSARY.map((t) => ({
      "@type": "DefinedTerm",
      name: t.term,
      description: t.short,
      url: `https://www.akhusbilfritid.se/ordlista/${t.slug}`,
    })),
  }),
  head: ({ loaderData }) => ({
    meta: [
      { title: "Husbils­ordlista — 30+ termer förklarade | AK Husbil" },
      { name: "description", content: "Vad betyder alkov, dubbla golv, litium, Alde, kassetttoalett? Vår ordlista förklarar husbils­termerna kort och tydligt. 30+ ord." },
      { property: "og:title", content: "Husbils­ordlista — alla termer förklarade" },
      { property: "og:description", content: "30+ husbils­termer förklarade av branschexperter. Alkov, dubbla golv, Alde, litium och mer." },
      { property: "og:url", content: "https://www.akhusbilfritid.se/ordlista" },
    ],
    links: [{ rel: "canonical", href: "https://www.akhusbilfritid.se/ordlista" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "DefinedTermSet",
          name: "Husbilsordlista",
          url: "https://www.akhusbilfritid.se/ordlista",
          inLanguage: "sv-SE",
          publisher: { "@id": "#organization" },
          hasDefinedTerm: loaderData?.terms ?? [],
        }),
      },
    ],
  }),
  component: OrdlistaIndex,
});

function OrdlistaIndex() {
  const grouped = GLOSSARY.reduce<Record<string, typeof GLOSSARY>>((acc, t) => {
    (acc[t.category] ||= []).push(t);
    return acc;
  }, {});
  return (
    <>
      <PageHeader label="Ordlista" title="Husbils­ordlista" sub={`${GLOSSARY.length} termer — allt från alkov till växelriktare`} />
      <main className="max-w-4xl mx-auto px-4 py-10 space-y-10">
        <p className="text-lg text-muted-foreground">
          Alla husbils­termer förklarade av oss som jobbar med dem dagligen. Klicka på en term för längre förklaring.
        </p>
        {Object.entries(grouped).map(([cat, list]) => (
          <section key={cat}>
            <h2 className="text-xl font-bold mb-4">{cat}</h2>
            <div className="grid sm:grid-cols-2 gap-3">
              {list.map((t) => (
                <Link
                  key={t.slug}
                  to="/ordlista/$term"
                  params={{ term: t.slug }}
                  className="rounded-lg border p-4 hover:border-primary hover:bg-muted/40"
                >
                  <div className="font-semibold">{t.term}</div>
                  <div className="text-sm text-muted-foreground line-clamp-2 mt-1">{t.short}</div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </main>
    </>
  );
}
